import { render, staticRenderFns } from "./projectOverview.vue?vue&type=template&id=6b3b597a&scoped=true"
import script from "./projectOverview.vue?vue&type=script&lang=js"
export * from "./projectOverview.vue?vue&type=script&lang=js"
import style0 from "./projectOverview.vue?vue&type=style&index=0&id=6b3b597a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b597a",
  null
  
)

export default component.exports